import { getAuthToken } from "../util/auth";
import createAxiosInstance, {API_URL_BASE} from "../util/axiosInstance";

const api = createAxiosInstance('/socios');

// 👉 NUEVO: instancia para certificados
const apiCert = createAxiosInstance('/certificados');

// Utilidad: generar código legible y único (frontend)
// CR = Certificado de Registro, CS = Solvencia
export function buildCertCode(socio, tipo = 'REGISTRO') {
  const sigla = (tipo || '').toUpperCase().startsWith('SOL') ? 'CS' : 'CR';
  const init =
    (socio?.apPat?.[0] || '') +
    (socio?.apMat?.[0] || '') +
    (socio?.nombres?.split(' ')[0]?.[0] || '');
  const initials = init.toUpperCase() || 'XX';
  const cod = (socio?.codreg || socio?.id || '0000').toString().replace(/\s+/g,'');
  const now = new Date();
  const y = now.getFullYear();
  const MM = String(now.getMonth()+1).padStart(2,'0');
  const dd = String(now.getDate()).padStart(2,'0');
  const hh = String(now.getHours()).padStart(2,'0');
  const mm = String(now.getMinutes()).padStart(2,'0');
  const ss = String(now.getSeconds()).padStart(2,'0');
  const rand = Math.random().toString(36).slice(2,6).toUpperCase();
  // Ej: CR-ABC-1234-20250909-223512-7FQZ
  return `${sigla}-${initials}-${cod}-${y}${MM}${dd}-${hh}${mm}${ss}-${rand}`;
}

// 👉 NUEVO: POST crear certificado (el backend puede ignorar 'codigo' y generar el suyo)
const crearCertificado = async (payload) => {
  // payload esperado:
  // { id_socio, tipo: 'Certificado de Afiliación' | 'Certificado de Solvencia',
  //   titulos?: [], grado_texto?: string, texto_certificado?: string, codigo?: string }
  const response = await apiCert.post('/', payload);
  return response.data;
};

// 👉 NUEVO: GET público por código (para modal/QR)
const getCertificadoPublico = async (codigo) => {
  const { data } = await apiCert.get(`/code/${codigo}`);
  return data;
};

// ---- EXISTENTE (se conserva) ----
// services/socioService.js

export const getSocioPhoto = async (id) => {
  const { data } = await api.get(`/photo/${id}`); 
  console.log("fotoen service=",data.foto)
  return data?.foto || null; // ← string
};


const getFotoUrl = (id) => {
  const token = getAuthToken();
  const timestamp = new Date().getTime();
  return `${API_URL_BASE}/socios/photo/${id}?token=${token}&timestamp=${timestamp}`;
};

const fetchSocios = () => api.get('/');
const fetchSocio  = (id) => api.get(`/${id}`);

const createSocio = (data) => api.post('/', data, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

const updateSocio = (id, data) => api.put(`/${id}`, data, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

const deleteSocio = async (id) => {
  const response = await api.delete(`/${id}`);
  return response.data;
};

const getMaxCodreg = async () => {
  const response = await api.get(`/codreg/maxcodreg`,{});
  return response.data;
};

const getSocioVerificationToken = async (id) => {
  const response = await api.get(`/${id}/verification-token`);
  return response.data;
};

export default {
  fetchSocios,
  fetchSocio,
  createSocio,
  updateSocio,
  deleteSocio,
  getMaxCodreg,
  getFotoUrl,
  getSocioPhoto,
  getSocioVerificationToken,

  // 👉 nuevos:
  crearCertificado,
  getCertificadoPublico,
};
